export class CannotCreateEligibilitySubmission extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'CannotCreateEligibilitySubmission'
    }
}

export class CannotGetQuestions extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'CannotGetQuestions'
    }
}

export class PersonalDetailsMissing extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'PersonalDetailsMissing'
    }
}

export class PostalCodeMissing extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'PostalCodeMissing'
    }
}

export class HasAnAdvisor extends Error {
    advisorUrl: string | undefined

    constructor(message: string, advisorUrl: string | undefined) {
        super(message)
        this.name = 'HasAnAdvisor'
        this.advisorUrl = advisorUrl
    }
}

export class StateAlreadyFilled extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'StateAlreadyFilled'
    }
}
